// Merkan · Englisches Wörterbuch: Kern (Formatierung, Oberflächenbausteine, Rahmen, Anmeldung,
// Übersicht, Auswertungen, Wiki, Einstellungen, Assistent und Suche)
export default {
  // Formatierung und relative Zeit
  'gerade eben': 'just now',
  'vor {n} Min.': '{n} min ago',
  'heute {zeit}': 'today {zeit}',
  'gestern {zeit}': 'yesterday {zeit}',
  'vor {n} Tagen': '{n} days ago',

  // Schritte und Phasen
  'Absender prüfen': 'Check sender',
  'Artikel erfassen': 'Capture items',
  'Lieferantenanfrage': 'Supplier enquiry',
  'Angebote und Kalkulation': 'Quotes and costing',
  'Angebot an Kunden': 'Quotation to customer',
  'Auftrag freigeben': 'Approve order',
  'Vorkasse abwarten': 'Await payment in advance',
  'Beschaffung': 'Procurement',
  'Wareneingang': 'Goods receipt',
  'Versand an Kunden': 'Shipping to customer',
  'Zustellung': 'Delivery',
  'Zahlung': 'Payment',
  'Abgeschlossen': 'Completed',
  'Anfrage': 'Enquiry',
  'Angebot': 'Quotation',
  'Auftrag': 'Order',
  'Lieferung': 'Delivery',
  'Abrechnung': 'Invoicing',

  // Nachrichtenstatus und Kategorien
  'Neu': 'New',
  'In Bearbeitung': 'In progress',
  'Wartet auf Kunde': 'Awaiting customer',
  'Wartet auf Lieferant': 'Awaiting supplier',
  'Erledigt': 'Done',
  'Bestellung': 'Purchase order',
  'Rechnung': 'Invoice',
  'Lieferantenangebot': 'Supplier quote',
  'Bereitstellungsmeldung': 'Ready for collection notice',
  'Werbung': 'Advertising',
  'Sonstiges': 'Other',

  // Belegarten, Belegstatus, Steuerarten
  'Auftragsbestätigung': 'Order Confirmation',
  'Lieferschein': 'Delivery Note',
  'Gutschrift': 'Credit Note',
  'Entwurf': 'Draft',
  'Festgeschrieben': 'Finalised',
  'Bezahlt': 'Paid',
  'Storniert': 'Cancelled',
  'Inland': 'Domestic',
  'Innergemeinschaftlich': 'Intra-Community',
  'Ausfuhr Drittland': 'Export to non-EU country',
  'Seeschifffahrt (§ 4 Nr. 2 UStG)': 'Sea-going vessels (§ 4 No. 2 UStG)',

  // KI-Aufruf
  "{ki} konnte die Anfrage nicht bearbeiten.": "{ki} could not process the request.",
  "{ki} ist gerade nicht erreichbar. Bitte später erneut versuchen.": "{ki} is not available right now. Please try again later.",

  // Oberflächenbausteine und Fehlertexte
  'Pfad': 'Breadcrumb',
  'Suchen': 'Search',
  'Schließen': 'Close',
  'Abbrechen': 'Cancel',
  'Bestätigen': 'Confirm',
  'Dieser Eintrag existiert bereits (Nummer oder Name doppelt).': 'This entry already exists (duplicate number or name).',
  'Der Eintrag wird noch an anderer Stelle verwendet oder verweist auf etwas, das fehlt.': 'The entry is still in use elsewhere or refers to something that is missing.',
  'Dafür fehlt dir die Berechtigung.': 'You do not have permission to do this.',
  'Die IMO-Nummer ist ungültig (Prüfziffer stimmt nicht).': 'The IMO number is invalid (check digit does not match).',
  'Eine Eingabe ist ungültig. Bitte Pflichtfelder und Formate prüfen.': 'An entry is invalid. Please check required fields and formats.',
  'Ein Pflichtfeld fehlt.': 'A required field is missing.',
  'Die Sitzung ist abgelaufen. Bitte neu anmelden.': 'Your session has expired. Please sign in again.',
  'Keine Verbindung zum Server. Bitte Internetverbindung prüfen.': 'No connection to the server. Please check your internet connection.',
  'Unbekannter Fehler.': 'Unknown error.',
  'Kein Monatskontingent festgelegt': 'No monthly allowance set',
  '{n} % verbraucht': '{n} % used',
  '{n} % frei': '{n} % remaining',

  // Rahmen und Navigation
  'Übersicht': 'Overview',
  'Arbeit': 'Work',
  'Service Hub': 'Service Hub',
  'Vorgänge': 'Cases',
  'Stammdaten': 'Master Data',
  'Kunden': 'Customers',
  'Lieferanten': 'Suppliers',
  'Schiffe': 'Vessels',
  'Artikel': 'Items',
  'Finanzen': 'Finance',
  'Rechnungswesen': 'Accounting',
  'Auswertungen': 'Reports',
  'Wissen': 'Knowledge',
  'Wiki': 'Wiki',
  'Keine Gruppe': 'No group',
  'Mandant wählen': 'Select company',
  'Hauptmenü': 'Main menu',
  'Menü ausklappen': 'Expand menu',
  'Menü einklappen': 'Collapse menu',
  'Einstellungen': 'Settings',
  'Abmelden': 'Sign out',
  'Suchen nach Vorgang, Kunde, Schiff, IMO, Teilenummer …': 'Search for case, customer, vessel, IMO, part number …',
  'Strg /': 'Ctrl /',
  'Präsentationsmodus beenden': 'Exit presentation mode',
  'Präsentationsmodus: Beträge ausblenden': 'Presentation mode: hide amounts',
  'Assistent': 'Assistant',
  'Schnellzugriff': 'Quick access',
  'Hub': 'Hub',
  'Belege': 'Documents',
  'Mehr': 'More',
  'Menü': 'Menu',
  'Geschäftsführung': 'Management',
  'Innendienst': 'Sales office',
  'Buchhaltung': 'Accounts',
  'Auszubildende': 'Trainees',
  'Vertrieb': 'Sales',
  'Lesezugriff': 'Read only',
  'Administratoren': 'Administrators',

  // App, Anmeldung, Zugang
  'Kein Zugriff': 'No access',
  'Deine Rolle hat keinen Zugriff auf diesen Bereich. Die Rechte vergibt parlinex im Admin Center.': 'Your role has no access to this area. Permissions are granted by parlinex in the Admin Center.',
  'Lädt …': 'Loading …',
  'Willkommen bei Merkan': 'Welcome to Merkan',
  'Kein Mandant zugeordnet': 'No company assigned',
  'Dein Konto ist noch keinem Unternehmen zugeordnet. Bitte wende dich an parlinex.': 'Your account has not yet been assigned to a company. Please contact parlinex.',
  'Zugriff wird geprüft …': 'Checking access …',
  'Anmeldung fehlgeschlagen. Bitte E-Mail und Passwort prüfen.': 'Sign-in failed. Please check your email address and password.',
  'Anmeldung für eingeladene Nutzer': 'Sign-in for invited users',
  'E-Mail-Adresse oder Passwort ist falsch.': 'Email address or password is incorrect.',
  'Die Sicherheitsprüfung von Cloudflare ist abgelaufen. Bitte erneut anmelden.': 'The Cloudflare security check has expired. Please sign in again.',
  'Die Sicherheitsprüfung von Cloudflare wurde vom Server abgelehnt. E-Mail und Passwort wurden nicht geprüft. Bitte parlinex informieren.': 'The server rejected the Cloudflare security check. Email and password were not checked. Please inform parlinex.',
  'Die E-Mail-Adresse ist noch nicht bestätigt. Bitte den Link aus der Einladung öffnen.': 'The email address has not been confirmed yet. Please open the link from your invitation.',
  'Dieses Konto ist gesperrt. Bitte wende dich an parlinex.': 'This account is blocked. Please contact parlinex.',
  'Zu viele Anmeldeversuche. Bitte einige Minuten warten.': 'Too many sign-in attempts. Please wait a few minutes.',
  'Anmeldung für {mandant}': 'Sign in to {mandant}',
  "+ Baustein": "+ Block",
  "Akzentfarbe": "Accent colour",
  "Als Standard": "Set as default",
  "Alternativtext": "Alt text",
  "Auswählen": "Choose",
  "Baustein hinzufügen": "Add block",
  "Baustein löschen": "Delete block",
  "Bausteine an der Leiste ziehen und in eine andere Spalte oder Zeile fallen lassen. Leere Angaben entfallen in der Mail samt ihrer Zeile.": "Drag blocks by their handle and drop them into another column or row. Empty values are left out of the email together with their line.",
  "Bild entfernen": "Remove image",
  "Bilder": "Images",
  "Bilder hierher ziehen oder": "Drop images here or",
  "Bitte ein Bild als PNG, JPG oder GIF wählen.": "Please choose a PNG, JPG or GIF image.",
  "Breite": "Width",
  "Breite in Pixeln": "Width in pixels",
  "Breiten": "Widths",
  "Breiten in Prozent, z. B. 35/65": "Widths in percent, e.g. 35/65",
  "Das Bild ist größer als 3 MB.": "The image is larger than 3 MB.",
  "Das Bild konnte nicht gelesen werden.": "The image could not be read.",
  "Der Name „{name}“ kommt in einer Sprache doppelt vor.": "The name “{name}” is used twice in one language.",
  "Der bisherige Aufbau dieser Signatur wird ersetzt.": "The current layout of this signature will be replaced.",
  "Die Bausteine dieser Zeile werden entfernt.": "The blocks in this row will be removed.",
  "Eine gestaltete Vorlage erhält jeder Benutzer als weitere Signatur, mit Bildern, Spalten und Listen.": "Every user receives a designed template as an additional signature, with images, columns and lists.",
  "Einträge, einer je Zeile": "Entries, one per line",
  "Farbe": "Colour",
  "Fett": "Bold",
  "Firmenlogo": "Company logo",
  "Format": "Layout",
  "Format „{name}“ übernehmen?": "Apply layout “{name}”?",
  "Für alle Benutzer anlegen, die sie noch nicht haben": "Create for all users who do not have it yet",
  "Gestaltet": "Designed",
  "Gestaltete Signatur": "Designed signature",
  "Gestaltete Signaturen bearbeitest du unter Einstellungen, Persönlich.": "Edit designed signatures under Settings, Personal.",
  "Gestaltete Vorlage": "Designed template",
  "Gestaltete Vorlage anlegen": "Create designed template",
  "Gestaltete Vorlage entfernen": "Remove designed template",
  "Grau": "Grey",
  "Groß": "Large",
  "Größe": "Size",
  "In die andere Sprache kopiert. Texte dort bei Bedarf übersetzen.": "Copied to the other language. Translate the texts there if needed.",
  "Ist Standard": "Is default",
  "Jede Signatur braucht einen Namen.": "Every signature needs a name.",
  "Klein": "Small",
  "Leer": "Empty",
  "Linie oben": "Line above",
  "Link": "Link",
  "Link (optional)": "Link (optional)",
  "Link entfernen": "Remove link",
  "Links": "Links",
  "Links ohne Adresse erscheinen nicht.": "Links without an address are not shown.",
  "Max Muster": "John Sample",
  "Mehrere Signaturen je Sprache. Die Standardsignatur steht im Mail-Dialog vorne, die übrigen sind dort wählbar. Merkan wählt die Sprache des Kunden.": "Several signatures per language. The default signature comes first in the email dialog, the others can be selected there. Merkan uses the customer’s language.",
  "Merkan Standard": "Merkan standard",
  "Nach Deutsch kopieren": "Copy to German",
  "Nach Englisch kopieren": "Copy to English",
  "Nach hinten": "Move back",
  "Nach oben": "Move up",
  "Nach unten": "Move down",
  "Nach vorn": "Move forward",
  "Name der Signatur bei den Benutzern": "Name of the signature for users",
  "Neue Zeile": "New row",
  "Schrift": "Font",
  "Signatur des Postfachs": "Mailbox signature",
  "Signatur „{name}“ löschen?": "Delete signature “{name}”?",
  "Spalten": "Columns",
  "Tabelle": "Table",
  "Text Deutsch": "Text German",
  "Text Englisch": "Text English",
  "Text der Signatur": "Signature text",
  "Textfarbe": "Text colour",
  "Textsignatur": "Text signature",
  "Vorlage des Unternehmens": "Company template",
  "Vorschau der Signatur": "Signature preview",
  "Wert oder {variable}": "Value or {variable}",
  "Zeile": "Row",
  "Zeile entfernen": "Remove row",
  "Zeile löschen": "Delete row",
  "Zeile löschen?": "Delete row?",
  "Zeile nach oben": "Move row up",
  "Zeile nach unten": "Move row down",
  "Zeile {n}": "Row {n}",
  "Zweispaltig mit Logo": "Two columns with logo",
  "gestaltet": "designed",
  "{n} Bilder": "{n} images",
  "{n} Einträge": "{n} entries",
  "{n} Spalte": "{n} column",
  "{n} Spalten": "{n} columns",
  "{n} px breit": "{n} px wide",
  "Überschrift": "Heading",
  'Datei ist bereit': 'File is ready',
  'Herunterladen': 'Download',
  'Teilen': 'Share',
  'PDF über das Teilen-Menü senden oder speichern': 'Send or save the PDF via the share menu',
  'PDF herunterladen': 'Download PDF',
  'Das Konto {email} hat keinen Zugang zu {mandant}. Bitte mit dem richtigen Konto anmelden.': 'The account {email} has no access to {mandant}. Please sign in with the correct account.',
  'E-Mail': 'Email',
  'Passwort': 'Password',
  'Anmelden …': 'Signing in …',
  'Anmelden': 'Sign in',
  'Sicherheitsprüfung …': 'Security check …',
  'Die Sicherheitsprüfung ist abgelaufen. Bitte erneut anmelden.': 'The security check has expired. Please sign in again.',
  'Die Sicherheitsprüfung ist fehlgeschlagen. Bitte die Seite neu laden.': 'The security check failed. Please reload the page.',
  'Die Sicherheitsprüfung konnte nicht geladen werden. Bitte Werbeblocker prüfen und die Seite neu laden.': 'The security check could not be loaded. Please check your ad blocker and reload the page.',
  'Lege dein Passwort fest. Mindestens 12 Zeichen.': 'Set your password. At least 12 characters.',
  'Neues Passwort': 'New password',
  'Passwort wiederholen': 'Repeat password',
  'Die Passwörter stimmen nicht überein.': 'The passwords do not match.',
  'Wird gespeichert …': 'Saving …',
  'Passwort speichern': 'Save password',
  'Der Zugriff auf diesen Mandanten ist derzeit nicht möglich.': 'Access to this company is not possible at the moment.',
  'Sitzung abgelaufen': 'Session expired',
  'Die maximale Sitzungsdauer für {mandant} ist erreicht. Bitte melde dich erneut an.': 'The maximum session length for {mandant} has been reached. Please sign in again.',
  'Netzwerk nicht freigegeben': 'Network not approved',
  '{mandant} erlaubt den Zugriff nur aus freigegebenen Netzwerken. Deine aktuelle Adresse ist {ip}. Bitte wende dich an deinen Administrator.': '{mandant} only allows access from approved networks. Your current address is {ip}. Please contact your administrator.',
  'unbekannt': 'unknown',
  'Der Zugriffsstatus konnte nicht geprüft werden. Bitte lade die Seite neu.': 'The access status could not be checked. Please reload the page.',
  'Neu anmelden': 'Sign in again',
  'Der Code ist ungültig oder abgelaufen. Bitte den aktuellen Code eingeben.': 'The code is invalid or has expired. Please enter the current code.',
  'Zweiten Faktor einrichten': 'Set up second factor',
  'Anmeldung bestätigen': 'Confirm sign-in',
  '{mandant} verlangt eine mehrstufige Anmeldung. Scanne den QR-Code mit einer Authenticator-App (z. B. Microsoft Authenticator) und gib den angezeigten Code ein.': '{mandant} requires multi-factor sign-in. Scan the QR code with an authenticator app (e.g. Microsoft Authenticator) and enter the code shown.',
  'QR-Code für die Authenticator-App': 'QR code for the authenticator app',
  'Ohne Kamera: Schlüssel manuell eingeben': 'Without a camera: enter the key manually',
  'Gib den 6-stelligen Code aus deiner Authenticator-App ein.': 'Enter the 6-digit code from your authenticator app.',
  'Code': 'Code',
  'Wird geprüft …': 'Checking …',

  // Übersicht
  'Kunde': 'Customer',
  'Lieferant': 'Supplier',
  'Interessent': 'Prospect',
  'Unbekannt': 'Unknown',
  'Intern': 'Internal',
  'Guten Morgen': 'Good morning',
  'Guten Tag': 'Good afternoon',
  'Guten Abend': 'Good evening',
  '{von}. bis {bis}': '{von} to {bis}',
  '{gruss}, {name}. Heute ist {heute}.': '{gruss}, {name}. Today is {heute}.',
  'Vorgang, Kunde, Schiff, IMO oder Teilenummer suchen': 'Search for case, customer, vessel, IMO or part number',
  'Kennzahlen': 'Key figures',
  'Offene Vorgänge': 'Open cases',
  'Neue Anfragen': 'New enquiries',
  'Vorgänge angelegt seit {datum}': 'Cases created since {datum}',
  'Vorgänge angelegt im Jahr {jahr}': 'Cases created in {jahr}',
  'Gebuchte und bezahlte Rechnungen im Jahr {jahr}': 'Posted and paid invoices in {jahr}',
  'Jahr {j}': 'Year {j}',
  'Zeitraum': 'Period',
  'vollständig bezahlt im Zeitraum': 'fully paid in the period',
  'Verkauft netto': 'Net sales',
  'Rohertrag': 'Gross profit',
  'keine Kalkulation': 'no costing',
  '{n} % vom Umsatz': '{n} % of revenue',
  'aus kalkulierten Vorgängen': 'from costed cases',
  'Offene Posten': 'Open Items',
  'davon überfällig': 'of which overdue',
  'nichts überfällig': 'nothing overdue',
  'Neue Nachrichten': 'New messages',
  'im Service Hub ungelesen': 'unread in the Service Hub',
  'Warnungen': 'Warnings',
  'Nächste Schritte': 'Next steps',
  'Alle Vorgänge': 'All cases',
  'Keine offenen Vorgänge': 'No open cases',
  'heute': 'today',
  'Neu im Service Hub': 'New in the Service Hub',
  'Zum Eingang': 'Go to inbox',
  'Keine Eingänge': 'No incoming messages',
  'neu': 'new',
  '(ohne Betreff)': '(no subject)',
  'KI-Kontingent': 'AI allowance',
  'Nur noch {n} % des Kontingents frei.': 'Only {n} % of the allowance remaining.',
  'Bei 0 % werden die KI-Funktionen angehalten.': 'At 0 % the AI functions will be paused.',
  'Bei 0 % laufen die KI-Funktionen weiter, der Mehrverbrauch wird im Folgemonat abgerechnet.': 'At 0 % the AI functions continue to run; additional usage is invoiced in the following month.',
  'Noch {n} % des Kontingents frei.': '{n} % of the allowance remaining.',
  'Das KI-Modul ist für diesen Mandanten nicht aktiv.': 'The AI module is not active for this company.',
  '{a} von {b} Tokens': '{a} of {b} tokens',
  '{n} überfällige Rechnung über {betrag}': '{n} overdue invoice totalling {betrag}',
  '{n} überfällige Rechnungen über {betrag}': '{n} overdue invoices totalling {betrag}',
  '{n} Kundenmail länger unbeantwortet': '{n} customer email unanswered for some time',
  '{n} Kundenmails länger unbeantwortet': '{n} customer emails unanswered for some time',
  '{n} Vorgang über dem Fälligkeitsdatum': '{n} case past its due date',
  '{n} Vorgänge über dem Fälligkeitsdatum': '{n} cases past their due date',
  "{n} Belegentwurf noch nicht ausgestellt": "{n} draft document not yet issued",
  "{n} Belegentwürfe noch nicht ausgestellt": "{n} draft documents not yet issued",
  '{n} Vorgang ist offen.': '{n} case is open.',
  '{n} Vorgänge sind offen.': '{n} cases are open.',
  "{n} Rechnung gebucht": "{n} invoice posted",
  "{n} Rechnungen gebucht": "{n} invoices posted",
  '{n} Tag überfällig': '{n} day overdue',
  '{n} Tage überfällig': '{n} days overdue',

  // Auswertungen
  '{n} Std.': '{n} hrs',
  '{n} Tage': '{n} days',
  'ohne Schiff': 'no vessel',
  'Name': 'Name',
  'Rechnungen': 'Invoices',
  'Umsatz netto': 'Net revenue',
  'Rohertrag %': 'Gross profit %',
  'Keine Rechnungen im Zeitraum': 'No invoices in this period',
  'Anteil': 'Share',
  'Vorgang ohne Kalkulation': 'Case without costing',
  'nicht kalkuliert': 'not costed',
  "Gebuchte und bezahlte Rechnungen seit {datum}": "Posted and paid invoices since {datum}",
  'Aufträge': 'Orders',
  'Vorgänge mit Bestellung oder Freigabe': 'Cases with purchase order or approval',
  'Angebotsquote': 'Quotation success rate',
  'keine Angebote': 'no quotations',
  '{a} von {b} Angeboten angenommen': '{a} of {b} quotations accepted',
  'Umsatz nach Monat': 'Revenue by month',
  'Umsatz nach Tag': 'Revenue by day',
  'Zeitraum {name}': 'Period: {name}',
  'Monat': 'Month',
  'Tag': 'Day',
  'Umsatz nach Kunde': 'Revenue by customer',
  'Umsatz nach Schiff': 'Revenue by vessel',
  'Schiff': 'Vessel',
  "Ausgestellte Angebote, angenommen mit Bestellnummer oder Auftrag": "Issued quotations accepted with a purchase order number or order",
  'Angebote': 'Quotations',
  'Angenommen': 'Accepted',
  'Quote %': 'Rate %',
  'Gesamt': 'Total',
  'Keine Angebote im Zeitraum': 'No quotations in this period',
  'Quote': 'Rate',
  'Durchlaufzeit je Schritt': 'Lead time per step',
  'Abgeschlossene Schritte im Zeitraum und aktuell wartende Vorgänge': 'Steps completed in the period and cases currently waiting',
  'Schritt': 'Step',
  'Durchläufe': 'Passes',
  'Mittel Stunden': 'Average hours',
  'Median Stunden': 'Median hours',
  'Offen': 'Open',
  'Wartet im Mittel Stunden': 'Average waiting hours',
  'Mittel': 'Average',
  'Median': 'Median',
  'Wartet': 'Waiting',
  'Rohertrag nur für Rechnungen aus kalkulierten Vorgängen. {a} von {b} Rechnungen ohne Kalkulation, Summe': 'Gross profit only for invoices from costed cases. {a} of {b} invoices without costing, total',
  'Balkendiagramm Umsatz': 'Revenue bar chart',
  '{n} Rechnung': '{n} invoice',
  '{n} Rechnungen': '{n} invoices',

  // Wiki
  'Prozesse': 'Processes',
  'Steuern': 'Tax',
  'Dokumente': 'Documents',
  'Versand': 'Shipping',
  'Markt': 'Market',
  "Von {ki} vorgeschlagen (KI)": "Suggested by {ki} (AI)",
  'Aus automatischem Abruf': 'From automatic retrieval',
  'Wissensbasis aktualisiert: {n} Einträge aufbereitet.': 'Knowledge base updated: {n} entries processed.',
  'Wissensbasis aktualisiert.': 'Knowledge base updated.',
  'Die Wissensbasis konnte gerade nicht aktualisiert werden.': 'The knowledge base could not be updated just now.',
  'Eintrag gespeichert': 'Entry saved',
  'Eintrag freigegeben': 'Entry approved',
  'Eintrag löschen?': 'Delete entry?',
  '„{titel}“ wird endgültig aus dem Wiki entfernt.': '“{titel}” will be permanently removed from the wiki.',
  'Löschen': 'Delete',
  'Eintrag gelöscht': 'Entry deleted',
  "Prozesse, Steuern, Dokumente und Marktwissen. {ki} greift auf freigegebene Einträge zu.": "Processes, taxes, documents and market knowledge. {ki} uses approved entries.",
  'Wird aktualisiert …': 'Updating …',
  'Wissensbasis jetzt aktualisieren': 'Update knowledge base now',
  'Neuer Eintrag': 'New entry',
  'Wiki durchsuchen': 'Search wiki',
  'Kategorie': 'Category',
  'Alle': 'All',
  'Nicht freigegeben': 'Not approved',
  'Keine passenden Einträge': 'No matching entries',
  'Noch keine Einträge': 'No entries yet',
  'Suchbegriff oder Kategorie ändern.': 'Change the search term or category.',
  'Stand {datum}': 'As of {datum}',
  'Alle Einträge': 'All entries',
  "Gespeichert. {ki} kennt dieses Wissen mit der nächsten stündlichen Aufbereitung der Wissensbasis.": "Saved. {ki} will know this after the next hourly knowledge base update.",
  "Dieser Eintrag ist nicht freigegeben. Nur Benutzer mit Freigaberecht sehen ihn, {ki} nutzt ihn erst nach der Freigabe.": "This entry is not approved. Only users with approval rights can see it; {ki} uses it only after approval.",
  'Quelle:': 'Source:',
  'Freigeben': 'Approve',
  'Bearbeiten': 'Edit',
  'Eintrag nicht gefunden': 'Entry not found',
  'Er wurde gelöscht oder ist für deine Rolle nicht sichtbar.': 'It has been deleted or is not visible to your role.',
  'Zur Übersicht': 'Back to overview',
  'Eintrag auswählen': 'Select an entry',
  'Links einen Eintrag wählen oder oben suchen.': 'Choose an entry on the left or search above.',
  'Eintrag bearbeiten': 'Edit entry',
  'Text in Markdown: # Überschrift, - Liste, **fett**, [Link](/vorgaenge/…)': 'Text in Markdown: # Heading, - List, **bold**, [Link](/vorgaenge/…)',
  'Speichern': 'Save',
  'Titel': 'Title',
  'Stand': 'As of',
  'Text': 'Text',
  'Vorschau': 'Preview',
  'Noch kein Text.': 'No text yet.',
  'Schlagworte': 'Keywords',
  'Durch Komma getrennt, z. B. Ausfuhr, ATLAS, Zoll': 'Separated by commas, e.g. export, ATLAS, customs',
  'Quelle': 'Source',
  'Gesetz, Merkblatt oder Link': 'Statute, guidance note or link',
  'Freigegeben (für alle mit Wiki-Zugriff und den Assistenten sichtbar)': 'Approved (visible to everyone with wiki access and to the assistant)',

  // Einstellungen: Abläufe
  'Die Prüfung konnte gerade nicht ausgeführt werden.': 'The check could not be run just now.',
  'Erinnerungen geprüft.': 'Reminders checked.',
  'Automatische Abläufe': 'Automated jobs',
  'Zeitgesteuerte Abläufe im Hintergrund. Fehlgeschlagene Läufe sind rot markiert, parlinex wird bei Ausfällen automatisch benachrichtigt.': 'Scheduled background jobs. Failed runs are marked in red; parlinex is notified automatically of any outages.',
  'Fehler {wann}': 'Error {wann}',
  'Zuletzt {wann}': 'Last run {wann}',
  'Läuft seit {wann}': 'Running since {wann}',
  'Noch kein Lauf': 'Not run yet',
  'Läuft …': 'Running …',
  'Jetzt ausführen': 'Run now',
  'Postfach': 'Mailbox',
  'Letzter Abruf': 'Last retrieval',
  'Zustand': 'Condition',
  'inaktiv': 'inactive',
  'noch nie': 'never',
  'ohne Fehler': 'no errors',
  'Jetzt abrufen': 'Retrieve now',
  'Für dieses Unternehmen wurden noch keine Läufe aufgezeichnet.': 'No runs have been recorded for this company yet.',
  'Zeit': 'Time',
  'Dauer': 'Duration',
  'Ergebnis': 'Result',
  'Meldung': 'Message',
  'Fehler': 'Error',
  'Erfolg': 'Success',
  'Läuft': 'Running',
  'Mailabruf': 'Mail retrieval',
  'Neue Nachrichten aller aktiven Postfächer abrufen': 'Retrieve new messages from all active mailboxes',
  'alle 2 Minuten': 'every 2 minutes',
  'Erinnerungen': 'Reminders',
  'Unbeantwortete Kundenmails und fällige Vorgänge markieren': 'Flag unanswered customer emails and cases due',
  'stündlich': 'hourly',
  'Wissensbasis aktualisieren': 'Update knowledge base',
  'Wiki und abgeschlossene Vorgänge für die KI aufbereiten': 'Prepare the wiki and completed cases for the AI',

  // Einstellungen: Navigation
  'Persönlich': 'Personal',
  'Für mich': 'For me',
  'Benutzer und Rollen': 'Users and roles',
  'Firmendaten': 'Company details',
  'Unternehmen': 'Company',
  'Postfächer': 'Mailboxes',
  'Textbausteine': 'Text templates',
  'KI und Kontingent': 'AI and allowance',
  'Betrieb': 'Operations',
  'Nummernkreise': 'Number ranges',
  'Änderungsprotokoll': 'Change log',
  'Für diesen Bereich fehlt deiner Rolle das Recht. Die Rechte vergibt parlinex im Admin Center.': 'Your role lacks the permission for this area. Permissions are granted by parlinex in the Admin Center.',

  // Einstellungen: Firmendaten
  'Firmendaten gespeichert': 'Company details saved',
  'Erscheinen im Briefkopf und Fuß aller Belege und in der Firmensignatur.': 'Shown in the letterhead and footer of all documents and in the company signature.',
  'Nur lesen. Ändern dürfen Benutzer mit dem Recht „Einstellungen bearbeiten“.': 'Read only. Users with the “Edit settings” permission can make changes.',
  'Firma': 'Company',
  'Straße und Hausnummer': 'Street and number',
  'PLZ': 'Postcode',
  'Ort': 'City',
  'Land': 'Country',
  'Ländercode, z. B. DE': 'Country code, e.g. DE',
  'Telefon': 'Phone',
  'Website': 'Website',
  'Steuern und Register': 'Tax and registration',
  'USt-IdNr.': 'VAT ID',
  'Steuernummer': 'Tax number',
  'Registergericht': 'Registry court',
  'Amtsgericht Hamburg': 'Hamburg Local Court',
  'Registernummer': 'Registration number',
  'Geschäftsführer': 'Managing director',
  'Bankverbindung': 'Bank details',
  'Bank': 'Bank',
  'Vorgänge und Service Hub': 'Cases and Service Hub',
  'Vorgangspräfix': 'Case prefix',
  'Ergibt Nummern wie {beispiel}': 'Produces numbers such as {beispiel}',
  'Erinnerung nach Stunden': 'Reminder after hours',
  'Unbeantwortete Kundenmails werden danach markiert (1 bis 720)': 'Unanswered customer emails are flagged after this time (1 to 720)',
  'Ungespeicherte Änderungen': 'Unsaved changes',
  'Firmendaten speichern': 'Save company details',

  // Einstellungen: KI
  'Mailauswertung': 'Email analysis',
  'Positionserkennung': 'Line item recognition',
  'Übersetzung': 'Translation',
  'Vorschläge': 'Suggestions',
  'Wissensbasis aufbereiten': 'Prepare knowledge base',
  'Ungültige E-Mail-Adresse: {liste}': 'Invalid email address: {liste}',
  'KI-Einstellungen gespeichert': 'AI settings saved',
  'Status der KI-Anbindung, Verbrauch dieses Monats und Verhalten, wenn das Kontingent aufgebraucht ist.': 'Status of the AI connection, usage this month and behaviour once the allowance is used up.',
  'Status': 'Status',
  'Verbunden': 'Connected',
  'Nicht verbunden': 'Not connected',
  'Anbindung': 'Connection',
  'Aktiv über die serverseitige KI-Funktion': 'Active via the server-side AI function',
  'Zugang': 'Access',
  'Eigener Workspace ({name})': 'Own workspace ({name})',
  'Eigener Workspace': 'Own workspace',
  'Allgemeiner Zugang von parlinex': 'General access provided by parlinex',
  'Nicht hinterlegt': 'Not stored',
  'Modelle': 'Models',
  'KI-Modul': 'AI module',
  'Freigeschaltet': 'Enabled',
  'Nicht freigeschaltet, bitte parlinex ansprechen': 'Not enabled, please contact parlinex',
  'Die KI ist derzeit nicht verbunden.': 'The AI is not connected at the moment.',
  "Ohne Verbindung laufen alle Funktionen weiter, nur ohne Vorschläge von {ki}.": "Without a connection everything keeps working, just without suggestions from {ki}.",
  'Kontingent': 'Allowance',
  'Abrechnungszeitraum {zeitraum}': 'Billing period {zeitraum}',
  'Tokens verbraucht': 'Tokens used',
  'Kosten bisher (Richtwert)': 'Cost to date (estimate)',
  'offen': 'open',
  'Monatskontingent': 'Monthly allowance',
  'frei bis {datum}': 'remaining until {datum}',
  'Das Monatskontingent ist Teil der Vereinbarung mit parlinex und wird dort eingestellt. Ab 30 % Rest wird der Balken orange, ab 20 % rot mit Warnmail an die Empfänger unten.': 'The monthly allowance is part of the agreement with parlinex and is set there. At 30 % remaining the bar turns orange, at 20 % red, with a warning email to the recipients below.',
  'Verbrauch nach Funktion': 'Usage by function',
  'In diesem Monat noch kein Verbrauch.': 'No usage yet this month.',
  'Funktion': 'Position',
  'Tokens': 'Tokens',
  'Verbrauch nach Tag': 'Usage by day',
  'In diesem Monat noch keine KI-Aufrufe.': 'No AI requests yet this month.',
  'Aufrufe': 'Requests',
  '({n} ohne Erfolg)': '({n} unsuccessful)',
  'Verhalten bei aufgebrauchtem Kontingent': 'Behaviour when the allowance is used up',
  'Änderungen werden im Änderungsprotokoll festgehalten.': 'Changes are recorded in the change log.',
  'Bei 0 % Rest': 'At 0 % remaining',
  'KI-Funktionen pausieren bis zum Monatsersten und zeigen einen Hinweis': 'AI functions pause until the first of the month and show a notice',
  'KI läuft weiter, Mehrverbrauch wird im Folgemonat abgerechnet': 'AI keeps running; additional usage is invoiced in the following month',
  'Stoppen': 'Stop',
  'Weiterlaufen': 'Continue',
  'Weiterlaufen mit Abrechnung im Folgemonat': 'Continue, invoiced in the following month',
  'Warnempfänger': 'Warning recipients',
  'E-Mail bei 20 % Rest und bei 0 %, einmal je Schwelle': 'Email at 20 % and at 0 % remaining, once per threshold',
  'geschaeftsfuehrung@firma.de': 'management@company.com',
  'Mehrere Adressen durch Komma trennen': 'Separate multiple addresses with commas',
  'keine': 'none',
  "So lernt {ki}": "How {ki} learns",
  'Rückmeldungen': 'Feedback',
  'Jeder Vorschlag wird angenommen, korrigiert oder abgelehnt. Korrekturen fließen als Beispiel in künftige Vorschläge ein.': 'Every suggestion is accepted, corrected or rejected. Corrections feed into future suggestions as examples.',
  'Beispiele': 'Examples',
  "Bei neuen Mails sucht {ki} ähnliche, bereits bestätigte Fälle und orientiert sich an ihnen.": "For new emails {ki} looks for similar, already confirmed cases and follows them.",
  'Entscheidungen': 'Decisions',
  'Wiederkehrende Wahlen wie Lieferant je Marke oder Aufschlag je Kunde werden gemerkt und vorgeschlagen.': 'Recurring choices such as supplier per make or mark-up per customer are remembered and suggested.',
  'Wissensbasis': 'Knowledge base',
  "Freigegebene Wiki-Einträge und abgeschlossene Vorgänge werden stündlich aufbereitet, damit {ki} sie kennt.": "Approved wiki entries and closed cases are processed every hour so {ki} knows them.",
  'Vorschläge angenommen': 'Suggestions accepted',
  'Vorschläge korrigiert': 'Suggestions corrected',
  'abgelehnt': 'rejected',
  'noch ohne Rückmeldung': 'no feedback yet',

  // Einstellungen: Nummernkreise
  'Belegnummern werden lückenlos und erst beim Festschreiben vergeben.': 'Document numbers are assigned without gaps and only on finalising.',
  'Startwerte und Präfixe setzt parlinex vor der ersten Vergabe. Danach sind Nummernkreise nicht mehr änderbar. Für Änderungen bitte parlinex ansprechen.': 'parlinex sets start values and prefixes before the first number is issued. After that number ranges can no longer be changed. Please contact parlinex for changes.',
  'Keine Nummernkreise eingerichtet': 'No number ranges set up',
  'Belegart': 'Document type',
  'Präfix': 'Prefix',
  'Nächste Nummer': 'Next number',
  'Stellen': 'Digits',
  'Beispiel': 'Example',
  'Vorgang': 'Case',
  'je Jahr ab 1': 'per year from 1',

  // Einstellungen: Persönlich
  'Diese Einstellungen gelten nur für dich und nur in diesem Unternehmen.': 'These settings apply only to you and only within this company.',
  'Darstellung': 'Display',
  'Sprache': 'Language',
  'Sprache der Oberfläche auf diesem Gerät. Die Seite lädt beim Wechsel neu.': 'Interface language on this device. The page reloads when you switch.',
  'Farbschema': 'Colour scheme',
  'System folgt der Einstellung deines Geräts': 'System follows your device setting',
  'Hell': 'Light',
  'Dunkel': 'Dark',
  'System': 'System',
  'Präsentationsmodus': 'Presentation mode',
  'Blendet alle Beträge und Preise aus, z. B. bei Vorführungen': 'Hides all amounts and prices, e.g. during demonstrations',
  'Eingeschaltet': 'On',
  'Ausgeschaltet': 'Off',
  'Zeitraum der Übersicht': 'Overview period',
  'Gilt für alle Kennzahlen auf der Startseite': 'Applies to all key figures on the home page',
  '7 Tage': '7 days',
  'Jahr': 'Year',
  'Standardabsender gespeichert': 'Default sender saved',
  'Standardabsender': 'Default sender',
  'Absender für neue Mails. Bei Antworten gilt das Postfach, in dem die Mail eingegangen ist.': 'Sender for new emails. Replies are sent from the mailbox that received the email.',
  'Du darfst derzeit aus keinem Postfach senden. Verbinde unten dein eigenes Postfach oder lass dir einen Zugriff freigeben.': 'You cannot currently send from any mailbox. Connect your own mailbox below or ask for access to be granted.',
  'Automatisch (eigenes Postfach, sonst Sammelpostfach)': 'Automatic (own mailbox, otherwise shared mailbox)',
  'Mein Postfach': 'My mailbox',
  'Dein persönliches Postfach. Nur du liest es, außer du gibst es für eine Vertretung frei.': 'Your personal mailbox. Only you can read it, unless you share it with a deputy.',
  'Noch kein eigenes Postfach verbunden. Dann sendest du aus dem Sammelpostfach mit der Firmensignatur.': 'No personal mailbox connected yet. You will send from the shared mailbox with the company signature.',
  'Mein Postfach verbinden': 'Connect my mailbox',
  'Signaturen gespeichert': 'Signatures saved',
  'Signaturen': 'Signatures',
  'Wird beim Senden aus deinem Postfach angehängt. Merkan wählt die Sprache des Kunden.': 'Added when sending from your mailbox. Merkan selects the customer’s language.',
  'Deutsch': 'German',
  'Englisch': 'English',
  'Ersetzt {funktion}': 'Replaces {funktion}',
  'Ersetzt {telefon}': 'Replaces {telefon}',
  'Signatur': 'Signature',
  'Noch keine Signatur.': 'No signature yet.',
  'Platzhalter einfügen:': 'Insert placeholder:',
  'Signaturen speichern': 'Save signatures',
  'Mein Zugang': 'My access',
  'Stand deiner Anmeldung laut Zugriffsrichtlinie des Unternehmens': 'Status of your sign-in under the company’s access policy',
  'Neu prüfen': 'Check again',
  'Zugriff erlaubt': 'Access granted',
  'Gesperrt': 'Blocked',
  'Anmeldung': 'Sign-in',
  'Mit zweitem Faktor bestätigt': 'Confirmed with second factor',
  'Nur erster Faktor': 'First factor only',
  'zweiter Faktor ist Pflicht': 'second factor is mandatory',
  'Sitzungsende': 'Session ends',
  'keine feste Grenze': 'no fixed limit',
  'IP-Adresse': 'IP address',

  // Einstellungen: Postfächer
  'Fehler seit {zeit}': 'Error since {zeit}',
  'Inaktiv': 'Inactive',
  'Aktiv': 'Active',
  'Sammelpostfächer wie info@ und persönliche Postfächer werden alle 2 Minuten abgerufen. Zugangsdaten liegen verschlüsselt im Tresor.': 'Shared mailboxes such as info@ and personal mailboxes are retrieved every 2 minutes. Credentials are stored encrypted in the vault.',
  'Neues Postfach': 'New mailbox',
  'Noch kein Postfach': 'No mailbox yet',
  'Lege das Sammelpostfach an, damit eingehende Mails im Service Hub erscheinen.': 'Set up the shared mailbox so that incoming emails appear in the Service Hub.',
  'Art': 'Type',
  'Sammelpostfach': 'Shared mailbox',
  'Hinterlegt': 'Stored',
  'Fehlt': 'Missing',
  'IMAP für den Abruf, SMTP für den Versand': 'IMAP for retrieval, SMTP for sending',
  'Postfach gespeichert, das Passwort konnte aber nicht gesetzt werden: {fehler}': 'Mailbox saved, but the password could not be set: {fehler}',
  'Postfach gespeichert': 'Mailbox saved',
  'Letzter Abruf fehlgeschlagen ({zeit})': 'Last retrieval failed ({zeit})',
  'Letzter Abruf fehlgeschlagen': 'Last retrieval failed',
  'E-Mail-Adresse': 'Email address',
  'info@firma.de': 'info@company.com',
  'Anzeigename': 'Display name',
  'Firma Service': 'Company Service',
  'Persönliches Postfach': 'Personal mailbox',
  'Inhaber': 'Owner',
  'Bitte wählen': 'Please select',
  'Abruf über IMAP': 'Retrieval via IMAP',
  'IMAP-Server': 'IMAP server',
  'imap.anbieter.de': 'imap.provider.com',
  'Port': 'Port',
  'Benutzer': 'User',
  'Leer lassen, wenn gleich der Adresse': 'Leave blank if same as the address',
  'Ordner': 'Folder',
  'Gesendet-Ordner': 'Sent folder',
  'Leer lassen: Merkan erkennt den Ordner selbst (Sent, Gesendete Elemente)': 'Leave blank: Merkan detects the folder itself (Sent, Sent Items)',
  'automatisch': 'automatic',
  'Gesendete Mails abrufen': 'Retrieve sent emails',
  'Antworten aus Outlook erscheinen dann im Verlauf und im Vorgang': 'Replies sent from Outlook then appear in the history and in the case',
  'Gesendet-Ordner mit abrufen': 'Also retrieve sent folder',
  'Versand über SMTP': 'Sending via SMTP',
  'SMTP-Server': 'SMTP server',
  'smtp.anbieter.de': 'smtp.provider.com',
  '465 mit SSL. Port 587 und 25 sind beim Hosting gesperrt.': '465 with SSL. Ports 587 and 25 are blocked by the hosting provider.',
  'SMTP-Benutzer': 'SMTP user',
  'Leer lassen, wenn gleich IMAP': 'Leave blank if same as IMAP',
  'Port {port} ist beim Hosting gesperrt. Bitte Port 465 verwenden.': 'Port {port} is blocked by the hosting provider. Please use port 465.',
  'hinterlegt': 'stored',
  'Passwort liegt verschlüsselt im Tresor. Nur ausfüllen, um es zu ersetzen.': 'The password is stored encrypted in the vault. Only fill in to replace it.',
  'Passwort liegt nach dem Speichern verschlüsselt im Tresor und wird nie wieder angezeigt.': 'After saving, the password is stored encrypted in the vault and never shown again.',
  'Neues Passwort setzen': 'Set new password',
  'Firmensignatur': 'Company signature',
  'Wird beim Senden aus diesem Postfach angehängt. Platzhalter {a} nennt den Bearbeiter, {b} und {c} kommen aus seiner persönlichen Signatur.': 'Added when sending from this mailbox. The placeholder {a} names the sender; {b} and {c} come from their personal signature.',
  'Aktiv (wird automatisch abgerufen)': 'Active (retrieved automatically)',
  'Wird getestet …': 'Testing …',
  'Verbindung testen': 'Test connection',
  'Wird abgerufen …': 'Retrieving …',
  'Postfach anlegen': 'Create mailbox',
  'Zugriffe': 'Access rights',
  'Sammelpostfächer lesen alle mit Service Hub. Senden erlaubt zusätzlich das Recht „Aus Sammelpostfach senden“ oder ein Haken hier.': 'Everyone with Service Hub access can read shared mailboxes. Sending additionally requires the “Send from shared mailbox” permission or a tick here.',
  'Persönliche Postfächer liest nur der Inhaber. Hier für Vertretungen freigeben.': 'Only the owner can read personal mailboxes. Grant access to deputies here.',
  'Lesen': 'Read',
  'Senden als': 'Send as',
  '{name} darf lesen': '{name} may read',
  '{name} darf senden': '{name} may send',

  // Einstellungen: Protokoll
  'Kontakte': 'Contacts',
  'Bezugsquellen': 'Sources',
  'Aggregate': 'Units',
  'Vorgangspositionen': 'Case line items',
  'Kalkulation': 'Costing',
  'Belegpositionen': 'Document line items',
  'Zahlungen': 'Payments',
  'Rollen': 'Roles',
  'Rollenrechte': 'Role permissions',
  'Gruppen': 'Groups',
  'Gruppenrollen': 'Group roles',
  'Gruppenmitglieder': 'Group members',
  'Mitgliedschaften': 'Memberships',
  'Module': 'Modules',
  'Zugriffsrichtlinie': 'Access policy',
  'Mandant': 'Company',
  'Angelegt': 'Created',
  'Geändert': 'Changed',
  'Gelöscht': 'Deleted',
  '30 Tage': '30 days',
  '90 Tage': '90 days',
  'Jede schreibende Aktion wird festgehalten. Einträge lassen sich nicht ändern oder löschen.': 'Every write action is recorded. Entries cannot be changed or deleted.',
  'Bereich': 'Area',
  'Alle Bereiche': 'All areas',
  'Keine Einträge im gewählten Zeitraum': 'No entries in the selected period',
  'Aktion': 'Action',
  'Datensatz': 'Record',
  'Wer': 'Who',
  'anderer Benutzer': 'another user',
  'Weitere {n} laden': 'Load {n} more',
  'Keine inhaltlichen Änderungen.': 'No changes to content.',
  'Feld': 'Field',
  'Alt': 'Old',

  // Einstellungen: Rechte
  'Benutzer, Gruppen und Rollen verwaltet parlinex im Admin Center. Für neue Kollegen oder geänderte Rechte bitte parlinex ansprechen.': 'parlinex manages users, groups and roles in the Admin Center. Please contact parlinex for new colleagues or changed permissions.',
  'Meine Gruppen': 'My groups',
  'in {mandant}': 'in {mandant}',
  'Keiner Gruppe zugeordnet': 'Not assigned to any group',
  'Meine Rechte': 'My permissions',
  'Bereiche sind Menüpunkte. Eine Funktion wirkt nur zusammen mit ihrem Bereich.': 'Areas are menu items. A function only takes effect together with its area.',
  'Nur lesen, keine weiteren Funktionen': 'Read only, no further functions',
  'Weitere': 'Other',

  // Rechtekatalog (Namen und Beschreibungen aus der Datenbank)
  'Eingang aller Postfächer, Nachrichten, Telefonnotizen': 'Inbox of all mailboxes, messages, phone notes',
  'Verkauf': 'Sales',
  'Vorgänge, Angebote, Aufträge': 'Cases, quotations, orders',
  'Einkauf': 'Purchasing',
  'Lieferantenanfragen und Bestellungen': 'Supplier enquiries and purchase orders',
  'Logistik': 'Logistics',
  'Versand, Abholungen, Wareneingang': 'Shipping, collections, goods receipt',
  'Kunden, Kontakte, Lieferanten, Artikel, Schiffe': 'Customers, contacts, suppliers, items, vessels',
  'Rechnungen, offene Posten, Zahlungen': 'Invoices, open items, payments',
  'Finanzbuchhaltung': 'Financial accounting',
  'DATEV-Übergabe': 'DATEV transfer',
  'Umsatz, Rohertrag, Quoten': 'Revenue, gross profit, success rates',
  'Kundenportal': 'Customer portal',
  'Portalzugänge für Kunden': 'Portal access for customers',
  'Wissensbasis mit Prozessen und Dokumenten': 'Knowledge base with processes and documents',
  'KI-Assistent': 'AI assistant',
  'Assistent, Mailauswertung, Positionserkennung, Übersetzung': 'Assistant, email analysis, line item recognition, translation',
  'Firmendaten, Postfächer, Textbausteine, Abläufe': 'Company details, mailboxes, text templates, automated jobs',
  'Nachrichten beantworten und zuordnen': 'Answer and assign messages',
  'Antworten, weiterleiten, Vorgängen zuordnen, Interessenten anlegen': 'Reply, forward, assign to cases, create prospects',
  'Automatische Antworten bearbeiten': 'Edit automatic replies',
  'Eingangsbestätigung und Regeln pflegen': 'Maintain acknowledgement of receipt and rules',
  'Aus Sammelpostfach senden': 'Send from shared mailbox',
  'Als info@ und andere Sammelpostfächer senden': 'Send as info@ and other shared mailboxes',
  'Vorgänge anlegen und bearbeiten': 'Create and edit cases',
  'Akten, Positionen, Belegentwürfe': 'Files, line items, draft documents',
  'Angebote senden': 'Send quotations',
  'Angebote erzeugen und an Kunden senden': 'Create quotations and send them to customers',
  'Kreditlimit entscheiden': 'Decide on credit limit',
  'Über Limitüberschreitung und Vorkasse entscheiden': 'Decide on credit limit excess and payment in advance',
  'Aufträge freigeben': 'Approve orders',
  'Freigabe nach Prüfliste': 'Approval according to checklist',
  'Anfragen und Bestellungen auslösen': 'Issue enquiries and purchase orders',
  'Einkaufspreise und Margen sehen': 'View purchase prices and margins',
  'Einkaufspreise, Kalkulation, Rohertrag': 'Purchase prices, costing, gross profit',
  'Versand und Abholungen buchen': 'Book shipping and collections',
  'Versanddienstleister wählen, Etiketten': 'Choose carriers, labels',
  'Wareneingang buchen': 'Book goods receipt',
  'Vollständigkeit prüfen, Teillieferungen': 'Check completeness, partial deliveries',
  'Stammdaten bearbeiten': 'Edit master data',
  'Kunden, Lieferanten, Artikel, Schiffe anlegen und ändern': 'Create and change customers, suppliers, items, vessels',
  'Kreditlimit ändern': 'Change credit limit',
  'Kreditlimit eines Kunden setzen': 'Set a customer’s credit limit',
  'Ausgangsrechnungen freigeben': 'Approve outgoing invoices',
  'Festschreiben und stornieren': 'Finalise and cancel',
  'Eingangsrechnungen freigeben': 'Approve incoming invoices',
  'Prüfen und zur Zahlung freigeben': 'Check and approve for payment',
  'Zahlungen buchen und mahnen': 'Book payments and send reminders',
  'Zahlungseingänge, Mahnungen': 'Incoming payments, dunning letters',
  'DATEV-Übergabe auslösen': 'Run DATEV transfer',
  'Buchungsstapel erzeugen': 'Create posting batch',
  'Portalzugänge verwalten': 'Manage portal access',
  'Zugänge für Kunden anlegen und sperren': 'Create and block customer access',
  'Wiki-Einträge bearbeiten und freigeben': 'Edit and approve wiki entries',
  'Einträge anlegen, ändern, freigeben': 'Create, change and approve entries',
  'KI-Verbrauch sehen und Kontingent einstellen': 'View AI usage and set allowance',
  'Verbrauch, Warnschwellen, Verhalten bei 0 %': 'Usage, warning thresholds, behaviour at 0 %',
  'Postfächer verwalten': 'Manage mailboxes',
  'Postfächer anlegen, verbinden, Zugriffe vergeben': 'Create and connect mailboxes, grant access',
  'Einstellungen bearbeiten': 'Edit settings',
  'Firmendaten, Textbausteine, Abläufe': 'Company details, text templates, automated jobs',
  'Änderungsprotokoll lesen': 'Read change log',
  'Wer hat wann was geändert': 'Who changed what and when',
  'Websuche im Assistenten': 'Web search in the assistant',
  'Der Assistent darf öffentliche Webseiten durchsuchen, wenn parlinex die Websuche für den Mandanten freigeschaltet hat': 'The assistant may search public websites if parlinex has enabled web search for the company',

  // Einstellungen: Textbausteine
  'Vorgangsnummer': 'Case number',
  'Belegnummer': 'Document number',
  'heutiges Datum': 'today’s date',
  'Name des Bearbeiters': 'Name of the person handling it',
  'Allgemein': 'General',
  'Eingangsbestätigung': 'Acknowledgement of receipt',
  'Erinnerung': 'Reminder',
  'Mahnung': 'Dunning letter',
  'Die Übersetzung ist gerade nicht möglich.': 'Translation is not available at the moment.',
  'Vorlagen für Antworten, Eingangsbestätigungen und Belegtexte. Jede Textänderung erzeugt eine neue Fassung, Belege merken sich die verwendete Fassung.': 'Templates for replies, acknowledgements of receipt and document texts. Every text change creates a new version; documents remember the version used.',
  'Neuer Textbaustein': 'New text template',
  'Textbausteine durchsuchen': 'Search text templates',
  'Keine passenden Textbausteine': 'No matching text templates',
  'Noch keine Textbausteine': 'No text templates yet',
  'Fassung': 'Version',
  'Englische Fassung vorhanden': 'English version available',
  'Deutsche Fassung vorhanden': 'German version available',
  'nur Deutsch': 'German only',
  'nur Englisch': 'English only',
  'Wird übersetzt …': 'Translating …',
  'Englische Fassung erzeugen': 'Create English version',
  'Deutsche Fassung erzeugen': 'Create German version',
  'Gespeichert als Fassung {n}': 'Saved as version {n}',
  'Textbaustein gespeichert': 'Text template saved',
  'Fassung {a}, wird beim Speichern zu Fassung {b}': 'Version {a}, becomes version {b} when saved',
  'Fassung {a}': 'Version {a}',
  'Beginnt mit Fassung 1': 'Starts at version 1',
  'Textbaustein bearbeiten': 'Edit text template',
  'Englische Fassung prüfen': 'Review English version',
  'Deutsche Fassung prüfen': 'Review German version',
  'Englische Fassung als neuen Baustein erzeugen': 'Create English version as a new template',
  'Deutsche Fassung als neuen Baustein erzeugen': 'Create German version as a new template',
  'Übersetzen': 'Translate',
  "Von {ki} übersetzt (KI). Bitte prüfen und speichern. Der Titel bleibt gleich, damit Merkan beide Fassungen einander zuordnet.": "Translated by {ki} (AI). Please check and save. The title stays the same so Merkan can link both versions.",
  'Übersetzter Titel zur Orientierung: {titel}': 'Translated title for reference: {titel}',
  'Eine englische Fassung ist vorhanden. Eine neue Übersetzung legt einen weiteren Baustein an.': 'An English version already exists. A new translation creates an additional template.',
  'Eine deutsche Fassung ist vorhanden. Eine neue Übersetzung legt einen weiteren Baustein an.': 'A German version already exists. A new translation creates an additional template.',
  'Platzhalter werden beim Einfügen in eine Mail oder einen Beleg durch die aktuellen Werte ersetzt: {liste}.': 'Placeholders are replaced with the current values when inserted into an email or document: {liste}.',
  'Aktiv (beim Antworten auswählbar)': 'Active (selectable when replying)',

  // Einstellungen: gemeinsame Mailtexte
  'Der Mailabruf konnte nicht ausgeführt werden.': 'Mail retrieval could not be carried out.',
  'Der Mailabruf ist gerade nicht erreichbar. Bitte später erneut versuchen.': 'Mail retrieval is currently unavailable. Please try again later.',
  'Keine Verbindung möglich.': 'Unable to connect.',
  '{n} neue Nachrichten abgerufen.': '{n} new messages retrieved.',
  'Keine neuen Nachrichten.': 'No new messages.',
  'Verbindung erfolgreich: {n} Nachrichten im Posteingang, davon {u} ungelesen': 'Connection successful: {n} messages in the inbox, {u} of them unread',
  'Verbindung erfolgreich: {n} Nachrichten im Posteingang': 'Connection successful: {n} messages in the inbox',
  '{n} Ordner ({liste})': '{n} folders ({liste})',
  'Gesendet-Ordner erkannt: {ordner}': 'Sent folder detected: {ordner}',
  'Kein Gesendet-Ordner erkannt, bitte unten eintragen': 'No sent folder detected, please enter it below',

  // Assistent
  'Suche': 'Search',
  'Internet': 'Internet',
  'Fasse diesen Vorgang zusammen': 'Summarise this case',
  'Was ist der nächste Schritt?': 'What is the next step?',
  'Welche Positionen sind noch unsicher?': 'Which line items are still uncertain?',
  'Was hat der Kunde zuletzt geschrieben?': 'What did the customer last write?',
  'Was ist bei diesem Kunden offen?': 'What is outstanding for this customer?',
  'Welche offenen Posten hat der Kunde?': 'What open items does the customer have?',
  'Welche Schiffe gehören dazu?': 'Which vessels belong to this customer?',
  'Wie war das Geschäft dieses Jahr?': 'How has business been this year?',
  'Was war zuletzt mit diesem Schiff?': 'What happened most recently with this vessel?',
  'Welche Teile haben wir für das Schiff geliefert?': 'Which parts have we supplied for this vessel?',
  'Wie hieß das Schiff früher?': 'What was this vessel previously called?',
  'Welche Mails sind heute dringend?': 'Which emails are urgent today?',
  'Welche Kundenmails sind unbeantwortet?': 'Which customer emails are unanswered?',
  'Gibt es neue Bereitstellungen von Lieferanten?': 'Are there new ready for collection notices from suppliers?',
  'Welche Rechnungen sind überfällig?': 'Which invoices are overdue?',
  'Wie hoch sind die offenen Posten?': 'How much is in open items?',
  'Welche Belegentwürfe sind offen?': 'Which draft documents are outstanding?',
  'Welche Vorgänge sind überfällig?': 'Which cases are overdue?',
  'Was steht heute an?': 'What is on today?',
  'Welche offenen Posten sind überfällig?': 'Which open items are overdue?',
  'Wie liefern wir steuerfrei an Seeschiffe?': 'How do we supply sea-going vessels tax-free?',
  'Heute': 'Today',
  'Gestern': 'Yesterday',
  'Letzte 7 Tage': 'Last 7 days',
  'Letzte 30 Tage': 'Last 30 days',
  'Älter': 'Older',
  'Verbindet': 'Connecting',
  "{ki} ist gerade nicht erreichbar.": "{ki} is not available right now.",
  "Die Verbindung zu {ki} wurde unterbrochen. Bitte erneut versuchen.": "The connection to {ki} was interrupted. Please try again.",
  'Unterhaltung': 'Conversation',
  '{n} Treffer': '{n} results',
  'Angeheftet': 'Pinned',
  'Verlauf': 'History',
  'Neue Unterhaltung': 'New conversation',
  'Verlauf durchsuchen': 'Search history',
  'Nichts gefunden.': 'Nothing found.',
  'Sucht …': 'Searching …',
  'Noch keine Unterhaltungen.': 'No conversations yet.',
  '{a} von {b} Begriffen': '{a} of {b} terms',
  'Umbenennen': 'Rename',
  'Verlauf ausblenden': 'Hide history',
  'Verlauf einblenden': 'Show history',
  'Fragen zu Vorgängen, Kunden, Schiffen und offenen Posten': 'Questions about cases, customers, vessels and open items',
  'Fragen zu deinem Unternehmen': 'Questions about your company',
  'Verkleinern': 'Reduce',
  'Groß anzeigen': 'Enlarge',
  'Einklappen (Esc)': 'Collapse (Esc)',
  'Einklappen': 'Collapse',
  'Beenden': 'Close',
  'Wie kann ich helfen?': 'How can I help?',
  'Ich kenne die Vorgänge, Kunden, Schiffe, Belege und das Wiki dieses Unternehmens, so weit deine Rolle sie sehen darf.': 'I know this company’s cases, customers, vessels, documents and wiki, as far as your role is allowed to see them.',
  'Denkt nach': 'Thinking',
  'Kopieren': 'Copy',
  'Hilfreich': 'Helpful',
  'Nicht hilfreich': 'Not helpful',
  'Neu beantworten': 'Answer again',
  'Was war falsch oder fehlt? (optional)': 'What was wrong or missing? (optional)',
  'Senden': 'Send',
  'Weiter fragen …': 'Ask a follow-up …',
  'Frage stellen …': 'Ask a question …',
  'Frage an den Assistenten': 'Question for the assistant',
  'Antwort stoppen': 'Stop answer',
  'Senden (Enter)': 'Send (Enter)',
  'Enter sendet, Shift und Enter für neue Zeile. Mit „Merke dir: …“ hältst du Wissen fest.': 'Enter sends, Shift and Enter for a new line. Use “Remember: …” to record knowledge.',
  'KI-Kontingent {zeitraum}': 'AI allowance {zeitraum}',
  '{n} % des Kontingents': '{n} % of allowance',
  'Kein Kontingent festgelegt': 'No allowance set',
  "{ki} öffnen": "Open {ki}",
  "{ki} fragen": "Ask {ki}",
  "{ki} ausblenden": "Hide {ki}",

  // Suche
  'Nachrichten': 'Messages',
  'Zuletzt geöffnet': 'Recently opened',
  'Schnellaktionen': 'Quick actions',
  'Neue Telefonnotiz': 'New phone note',
  'Neuer Vorgang': 'New case',
  'Vorgang, Kunde, Schiff, IMO, Teilenummer, Beleg …': 'Case, customer, vessel, IMO, part number, document …',
  'Suchbegriff': 'Search term',
  'Keine Treffer für „{q}“.': 'No results for “{q}”.',
  'Bitte mindestens zwei Zeichen eingeben.': 'Please enter at least two characters.',
  'auswählen': 'select',
  'öffnen': 'open',
  'schließen': 'close',
  'Exakte Nummer oder IMO und Enter öffnet direkt': 'Exact number or IMO plus Enter opens directly',

  // Design System (DS-05 bis DS-11)
  'Waren': 'Goods',
  'Menü öffnen': 'Open menu',
  'Speichert …': 'Saving …',
  'erledigt': 'done',
  'aktuell': 'current',
  'Vorgangsfortschritt': 'Case progress',
  // Kopfleiste: Darstellung
  'Darstellung: {jetzt}. Wechseln zu {naechste}': 'Display: {jetzt}. Switch to {naechste}',

  // Einstellungen: Signaturen, Logo, Signaturvorlage, Variablen, Standardbausteine (0021)
  'Alle Benutzer haben bereits eine Signatur.': 'All users already have a signature.',
  'Alle Standardbausteine sind bereits vorhanden.': 'All standard templates already exist.',
  'Bestehende Signaturen bleiben unverändert.': 'Existing signatures remain unchanged.',
  'Bitte eine PNG-, JPG- oder SVG-Datei wählen.': 'Please choose a PNG, JPG or SVG file.',
  'Claim': 'Tagline',
  'Das Logo ist nach der Aufbereitung größer als 400 KB. Bitte eine kleinere oder einfachere Datei verwenden.': 'After processing, the logo is larger than 400 KB. Please use a smaller or simpler file.',
  'Das Unternehmen hat noch kein Logo hinterlegt (Einstellungen, Firmendaten).': 'The company has not added a logo yet (Settings, Company details).',
  'Die Datei ist zu groß. Bitte höchstens 5 MB hochladen.': 'The file is too large. Please upload 5 MB at most.',
  'Die Datei konnte nicht als Bild gelesen werden.': 'The file could not be read as an image.',
  'Entfernen': 'Remove',
  'Erscheint in Signaturen und Belegen. SVG wird beim Hochladen in ein PNG mit doppelter Auflösung umgewandelt, damit Outlook es anzeigt.': 'Appears in signatures and documents. SVG files are converted to a PNG at double resolution on upload so that Outlook displays them.',
  'Ersetzt {variable}': 'Replaces {variable}',
  'Erst speichern, dann für alle anlegen': 'Save first, then create for all',
  'Fax': 'Fax',
  'Für alle Benutzer ohne Signatur anlegen': 'Create for all users without a signature',
  'Für diesen Prozessschlüssel gibt es in dieser Sprache bereits einen Textbaustein.': 'A template with this process key already exists in this language.',
  'Grundlage für neue Benutzer. Jeder passt seine Signatur danach unter Persönlich an.': 'Basis for new users. Everyone can then adjust their signature under Personal.',
  'Größe: {kb} KB': 'Size: {kb} KB',
  'Kein Logo hinterlegt': 'No logo added',
  'Keine passende Variable': 'No matching variable',
  'Kurzer Leitsatz unter dem Logo, z. B. im Briefkopf': 'Short tagline below the logo, e.g. in the letterhead',
  'Leere Angaben entfallen in der Mail samt ihrer Zeile.': 'Empty details are left out of the email together with their line.',
  'Legt für jeden Prozessschritt einen Baustein in Deutsch und Englisch an, sofern er noch fehlt': 'Creates a German and an English template for each process step where one is missing',
  'Logo': 'Logo',
  'Logo anzeigen': 'Show logo',
  'Logo ersetzen': 'Replace logo',
  'Logo hochladen': 'Upload logo',
  'Logo und Claim': 'Logo and tagline',
  'Ohne eigene Vorlage gilt die Standardvorlage.': 'Without a custom template, the standard template applies.',
  'PNG, JPG oder SVG, höchstens 400 KB nach der Aufbereitung. Angezeigt mit höchstens 240 x 80 Pixeln.': 'PNG, JPG or SVG, at most 400 KB after processing. Displayed at up to 240 x 80 pixels.',
  'Prozessschlüssel': 'Process key',
  'Signaturvorlage': 'Signature template',
  'Standardbausteine anlegen': 'Create standard templates',
  'Standardvorlage übernehmen': 'Use standard template',
  'Variable einfügen': 'Insert variable',
  'Variable suchen': 'Search variables',
  'Variablen werden beim Einfügen in eine Mail oder einen Beleg durch die aktuellen Werte ersetzt.': 'Variables are replaced with current values when inserted into an email or document.',
  'Verknüpft Deutsch und Englisch, z. B. angebot_senden': 'Links German and English, e.g. angebot_senden',
  "Von {ki} übersetzt (KI). Bitte prüfen und speichern. Der Prozessschlüssel verknüpft beide Fassungen.": "Translated by {ki} (AI). Please check and save. The process key links both versions.",
  'Vorlage': 'Template',
  'Vorlage des Unternehmens übernehmen': 'Use company template',
  'Vorschau mit Beispielwerten': 'Preview with sample values',
  'Wird aufbereitet …': 'Processing …',
  'optional': 'optional',
  '{n} Signatur angelegt': '{n} signature created',
  '{n} Signaturen angelegt': '{n} signatures created',
  '{n} Standardbaustein angelegt': '{n} standard template created',
  '{n} Standardbausteine angelegt': '{n} standard templates created',

  // Variablenkatalog (src/lib/variablen.ts)
  'Briefanrede': 'Salutation',
  'Vollständiger Name': 'Full name',
  'Zahlungsziel (Tage)': 'Payment terms (days)',
  'Lieferantennummer': 'Supplier number',
  'Referenz des Kunden': 'Customer reference',
  'Längste Lieferzeit (Tage)': 'Longest delivery time (days)',
  'Schiffsname': 'Vessel name',
  'IMO': 'IMO',
  'Betrag brutto': 'Gross amount',
  'Offener Betrag': 'Outstanding amount',
  'Ihr Name': 'Your name',
  'Ihr Vorname': 'Your first name',
  'Ihre Funktion': 'Your position',
  'Ihre Telefonnummer': 'Your phone number',
  'Ihre E-Mail': 'Your email',
  'Firmenname': 'Company name',
  'Anschrift einzeilig': 'Address on one line',
  'Registerangaben': 'Register details',
  'Heutiges Datum': 'Today\'s date',

  // Formulierung verbessern (KI-Aktion formulieren)
  'Formulierung verbessern': 'Improve wording',
  'Wird überarbeitet …': 'Revising …',
  'Überarbeitet den Text nach dem Schreibstil, Fakten und Variablen bleiben unverändert': 'Revises the text in line with the house style; facts and variables remain unchanged',
  'Die Formulierung kann gerade nicht verbessert werden.': 'The wording cannot be improved at the moment.',
  'Die Formulierung entspricht bereits dem Schreibstil.': 'The wording already meets the house style.',
  'Vorschlag': 'Suggestion',
  'Vorschlag übernehmen': 'Apply suggestion',
  'Verwerfen': 'Discard',
  'Änderbar unter Nummernkreise. Ergibt Nummern wie {beispiel}': 'Change under Number ranges. Produces numbers such as {beispiel}',
  "Anrede (Herr/Frau)": "Title (Mr/Ms)",
  "Land (Code)": "Country (code)",
  "EORI": "EORI",
  "Offene Posten gesamt": "Total open items",
  "Übliche Lieferzeit (Tage)": "Usual lead time (days)",
  "Angelegt am": "Created on",
  "Aktueller Schritt": "Current step",
  "Anzahl Positionen": "Number of line items",
  "Positionsliste (mehrzeilig)": "Line item list (multi-line)",
  "Auftragswert netto": "Order value net",
  "Zahlungsart des Vorgangs": "Payment terms of the case",
  "Angebotsnummer": "Quotation number",
  "Angebotsdatum": "Quotation date",
  "Angebotsbetrag brutto": "Quotation amount gross",
  "Angebotsbetrag netto": "Quotation amount net",
  "Gültig bis (30 Tage)": "Valid until (30 days)",
  "Auftragsbestätigungsnummer": "Order confirmation number",
  "Datum der Auftragsbestätigung": "Order confirmation date",
  "Auftragsbetrag brutto": "Order amount gross",
  "Rechnungsnummer": "Invoice number",
  "Rechnungsdatum": "Invoice date",
  "Rechnungsbetrag brutto": "Invoice amount gross",
  "Rechnungsbetrag netto": "Invoice amount net",
  "Anzahlungsrechnung Nummer": "Advance invoice number",
  "Anzahlungsbetrag": "Advance payment amount",
  "Schlussrechnung Nummer": "Final invoice number",
  "Schlussrechnung Restbetrag": "Final invoice balance",
  "Lieferscheinnummer": "Delivery note number",
  "Letzte Zahlung am": "Last payment on",
  "Letzter Zahlbetrag": "Last payment amount",
  "Bisher bezahlt (Vorgang)": "Paid so far (case)",
  "Noch offen (Vorgang)": "Still open (case)",
  "Unsere IBAN": "Our IBAN",
  "Unsere BIC": "Our BIC",
  "Unsere Bank": "Our bank",
  "Ihr Nachname": "Your surname",
  "IBAN": "IBAN",
  "BIC": "BIC",
  "Heutiges Datum ausgeschrieben": "Today's date in words",
  "Aktuelles Jahr": "Current year",
  "Uhrzeit": "Time",
  "Der Anhang konnte nicht erzeugt werden: {fehler}": "The attachment could not be created: {fehler}",
  "Der Anhang wird noch erzeugt.": "The attachment is still being created.",
  "Nachricht an {an} gesendet.": "Message sent to {an}.",
  "Es gibt kein Postfach, aus dem du senden darfst.": "There is no mailbox you are allowed to send from.",
  "Aus dem Textbaustein, Variablen sind bereits eingesetzt.": "From the template, variables already filled in.",
  "Wird nach dem Text eingefügt": "Inserted after the text",
  "Logo unter der Signatur": "Logo below the signature",
  "Anhänge": "Attachments",
  "Anhang entfernen": "Remove attachment",
  "Ohne Wert: {liste}. Bitte im Text ergänzen oder trotzdem senden.": "No value: {liste}. Please complete the text or send anyway.",
  "Sendung": "Shipment",
  "Bestellnummer": "Order number",
  "Bestelldatum": "Order date",
  "Liefertermin laut AB": "Delivery date as acknowledged",
  "AB-Nummer des Lieferanten": "Supplier acknowledgement no.",
  "Versanddatum": "Dispatch date",
  "Versandart": "Mode of transport",
  "Spediteur": "Forwarder",
  "Sendungsnummer": "Tracking number",
  "Lieferung an": "Delivery to",
  "Anzahl Colli": "Number of packages",
  "Zugestellt am": "Delivered on",
  "Arbeitsbereich": "Workspace",
  "Umsatz nach Hersteller": "Revenue by maker",
  "Umsatz nach Lieferant": "Revenue by supplier",
  "Aus den Positionen der berechneten Vorgänge, Spalte Rechnungen zählt Vorgänge": "From the items of invoiced cases, the invoices column counts cases",
  "Lieferant laut Kalkulation je Position": "Supplier as per costing for each item",
  "ohne Hersteller": "no maker",
  "{n} Angebot seit 7 Tagen ohne Rückmeldung": "{n} quotation without response for 7 days",
  "{n} Angebote seit 7 Tagen ohne Rückmeldung": "{n} quotations without response for 7 days",
  "{n} Bestellung ohne Lieferanten-AB nach 2 Werktagen": "{n} purchase order without acknowledgement after 2 working days",
  "{n} Bestellungen ohne Lieferanten-AB nach 2 Werktagen": "{n} purchase orders without acknowledgement after 2 working days",
  "{n} Liefertermin des Lieferanten überschritten": "{n} supplier delivery date exceeded",
  "{n} Liefertermine von Lieferanten überschritten": "{n} supplier delivery dates exceeded",
  "Kennzahlen werden geladen": "Loading key figures",
  "Deine Rechnung wird eingelesen": "Reading your invoice",
  "Das Angebot wird eingelesen": "Reading the quotation",
  "Dein Lieferschein wird eingelesen": "Reading your delivery note",
  "Dein Kontoauszug wird eingelesen": "Reading your bank statement",
  "Der Beleg wird eingelesen": "Reading the document",
  "Kopf und Absender werden gelesen": "Reading header and sender",
  "Positionen werden Zeile für Zeile erfasst": "Capturing items line by line",
  "Teilenummern werden Zeichen für Zeichen übernommen": "Copying part numbers character by character",
  "Steuersätze und Summen werden gelesen": "Reading VAT rates and totals",
  "Gleich siehst du das Ergebnis": "The result is almost ready",
  "Preise werden erfasst": "Capturing prices",
  "Lieferzeiten werden in Tage umgerechnet": "Converting delivery times into days",
  "Gleich siehst du das Angebot": "The quotation is almost ready",
  "Bestellnummern werden gesucht": "Looking for order numbers",
  "Gelieferte Mengen werden gezählt": "Counting delivered quantities",
  "Handschriftliche Vermerke werden beachtet": "Taking handwritten notes into account",
  "Gleich siehst du, zu welcher Bestellung er gehört": "You will see which order it belongs to in a moment",
  "Buchungen werden erfasst": "Capturing transactions",
  "Soll und Haben werden sortiert": "Sorting debits and credits",
  "Verwendungszwecke werden gelesen": "Reading payment references",
  "Gleich siehst du die Buchungen": "The transactions are almost ready",
  "Die Belegart wird bestimmt": "Determining the document type",
  "Inhalte werden erfasst": "Capturing the content",
  "Der Lotse ist an Bord": "The pilot is on board",
  "Kurs auf die Summenzeile": "Setting course for the totals",
  "Die Ladung wird gelöscht, Zeile für Zeile": "Discharging the cargo, line by line",
  "Fast im Hafen": "Almost in port",
  "Menge mal Preis, Zeile für Zeile nachgerechnet": "Quantity times price, checked line by line",
  "Lieferant wird im Stamm gesucht": "Looking up the supplier",
  "Artikel werden mit dem Stamm abgeglichen": "Matching items against the item master",
  "E-Rechnungen als XML liest Merkan in unter einer Sekunde, ganz ohne KI.": "Merkan reads e-invoices in XML in under a second, without any AI.",
  "Mehrseitige Rechnungen: alle Fotos auf einmal auswählen, Merkan liest sie als ein Dokument.": "Multi-page invoices: select all photos at once and Merkan reads them as one document.",
  "Fotos gerade und bei gutem Licht aufnehmen, dann liest {ki} am sichersten.": "Take photos straight on and in good light so {ki} reads them most reliably.",
  "Merkan rechnet jede Zeile im Code nach und meldet Abweichungen.": "Merkan recalculates every line and reports differences.",
  "Geänderte Bankverbindungen auf Rechnungen werden immer als Hinweis gemeldet.": "Changed bank details on invoices are always flagged.",
  "Deine Korrekturen in der Prüfmaske verbessern die Erkennung.": "Your corrections in the review form improve recognition.",
  "Rechnungen aus Mails lassen sich im Service Hub direkt am Anhang auswerten.": "Invoices received by email can be read directly from the attachment in the Service Hub.",
  "Fertig, gleich siehst du das Ergebnis": "Done, here comes the result",
  "E-Rechnung wird direkt gelesen": "Reading the e-invoice directly",
  "Datei wird übertragen": "Uploading the file",
  "Auszug von {name} erkannt": "Statement from {name} recognised",
  "Beleg von {name} erkannt": "Document from {name} recognised",
  "Hochgeladen": "Uploaded",
  "E-Rechnung lesen": "Read e-invoice",
  "{ki} liest den Beleg": "{ki} is reading the document",
  "Nachrechnen": "Recalculate",
  "Abgleich mit Lieferanten und Artikeln": "Match suppliers and items",
  "Lesestand anzeigen": "Show reading progress",
  "Fertig": "Done",
  "Wird gelesen": "Reading",
  "Deine E-Rechnung wird eingelesen": "Reading your e-invoice",
  "Im Hintergrund weiterlesen": "Continue in the background",
  "Fortschritt": "Progress",
  "Beträge werden nachgerechnet": "Recalculating amounts",
  "Schon erkannt": "Recognised so far",
  "Tipp": "Tip",
  "Seiten": "pages",
  "{n} Buchung gelesen": "{n} transaction read",
  "{n} Buchungen gelesen": "{n} transactions read",
  "{n} Position gelesen": "{n} item read",
  "{n} Positionen gelesen": "{n} items read",
  "{n} Zeile gelesen": "{n} line read",
  "{n} Zeilen gelesen": "{n} lines read",
  "{ki}": "{ki}",
  "Hallo, ich bin {ki}. Wie kann ich helfen?": "Hi, I'm {ki}. How can I help?",
  "Ich bin der KI-Assistent in Merkan und kenne die Vorgänge, Kunden, Schiffe, Belege und das Wiki dieses Unternehmens, so weit deine Rolle sie sehen darf.": "I'm the AI assistant in Merkan and know the cases, customers, vessels, documents and wiki of this company, as far as your role allows.",
  "Frage an {ki}": "Question to {ki}",
  "{ki}, dein KI-Assistent": "{ki}, your AI assistant",
  "Kartons werden ausgepackt, Zeile für Zeile": "Unpacking the boxes, line by line",
  "Die Ware sucht ihren Lagerplatz": "The goods are finding their shelf",
  "Lieferschein trifft Lager": "Delivery note meets warehouse",
  "Fast versandbereit": "Almost ready to ship",
  "Aufmaß wird genommen": "Taking measurements",
  "Zweimal messen, einmal buchen": "Measure twice, book once",
  "Die Wasserwaage liegt an": "Checking the spirit level",
  "Fast fertig montiert": "Almost fully installed",
  "Ordnung kommt in die Zahlen": "Bringing order to the numbers",
  "Jede Zeile bekommt ihren Platz": "Every line finds its place",
  "Kurz durchatmen": "Take a short breath",
  "Gleich geschafft": "Nearly done",
  "Gespeichert": "Saved",
  "Kunde, Rechnungen": "Customer, invoices",
  "Ungültige Adresse": "Invalid address",
  "{a} entfernen": "Remove {a}",
  "Mehrere Empfänger mit Enter oder Komma trennen; Vorschläge aus Kontakten, Kunden und Lieferanten.": "Separate several recipients with Enter or a comma; suggestions from contacts, customers and suppliers.",
  "Name oder name@firma.example": "Name or name@company.example",
  "Bcc": "Bcc",
  "Blindkopie: für die anderen Empfänger nicht sichtbar.": "Blind copy: not visible to the other recipients.",
  "Bcc {liste}": "Bcc {liste}",
  "Hohe Priorität": "High priority",
  // Sicherheitsprotokoll
  "Sicherheitsprotokoll": "Security log",
  "Anmeldungen und Änderungen an Passwort und zweitem Faktor aller Benutzer dieses Unternehmens. Einträge lassen sich nicht ändern oder löschen.": "Sign-ins and changes to password and second factor for all users of this company. Entries cannot be changed or deleted.",
  "Alle Benutzer": "All users",
  "Ereignis": "Event",
  "Gerät": "Device",
  "Ausgelöst von": "Triggered by",
  "parlinex Administration": "parlinex administration",
  "Benutzer selbst": "User",
  "Zweiter Faktor bestätigt": "Second factor confirmed",
  "Zweiter Faktor eingerichtet": "Second factor set up",
  "Zweiter Faktor entfernt": "Second factor removed",
  "Passwort festgelegt": "Password set",
  "Passwort geändert": "Password changed",
  "Passwort-Link angefordert": "Password link requested",
  "Zweiter Faktor zurückgesetzt": "Second factor reset",
  "Passwort-Link durch Administration gesendet": "Password link sent by administration",
  "Profil durch Administration geändert": "Profile changed by administration",
  "E-Mail-Adresse durch Administration geändert": "Email address changed by administration",
  "Postfachzugriffe": "Mailbox access",
  "DATEV-Exporte": "DATEV exports",
  "Belegversand": "Document dispatch",
  "Eingangsrechnungen": "Incoming invoices",
  "Eingangsrechnungspositionen": "Incoming invoice items",
  "Wareneingänge": "Goods receipts",
  // Zwei-Faktor-Anmeldung
  "Die Anmeldung konnte nicht vorbereitet werden. Bitte laden Sie die Seite neu.": "Sign-in could not be prepared. Please reload the page.",
  "Die Einrichtung konnte nicht gestartet werden. Bitte laden Sie die Seite neu.": "Setup could not be started. Please reload the page.",
  "Der Code ist ungültig oder abgelaufen. Bitte geben Sie den aktuellen Code ein.": "The code is invalid or has expired. Please enter the current code.",
  "Sechsstelliger Code": "Six-digit code",
  "Sicherheit für Ihr Konto": "Security for your account",
  "Einen Moment bitte": "One moment please",
  "Die sichere Anmeldung wird vorbereitet …": "Preparing secure sign-in …",
  "Zwei-Faktor-Anmeldung einrichten": "Set up two-factor sign-in",
  "Schützen Sie Ihren Merkan-Zugang für {mandant} mit einem zweiten Faktor. Lassen Sie uns die mehrstufige Anmeldung (MFA) jetzt gemeinsam einrichten, es dauert weniger als eine Minute.": "Protect your Merkan access for {mandant} with a second factor. Let us set up multi-factor authentication (MFA) together now, it takes less than a minute.",
  "Öffnen Sie eine Authenticator-App, zum Beispiel Microsoft Authenticator oder Google Authenticator.": "Open an authenticator app, for example Microsoft Authenticator or Google Authenticator.",
  "Scannen Sie den QR-Code mit der App.": "Scan the QR code with the app.",
  "Geben Sie den sechsstelligen Code aus der App unten ein.": "Enter the six-digit code from the app below.",
  "Konto manuell hinzufügen": "Add account manually",
  "Konto": "Account",
  "Schlüssel": "Key",
  "Schlüssel kopieren": "Copy key",
  "Kopiert": "Copied",
  "Zeitbasiert (TOTP), 6 Ziffern, 30 Sekunden": "Time-based (TOTP), 6 digits, 30 seconds",
  "QR-Code wieder anzeigen": "Show QR code again",
  "Scannen nicht möglich? Manuell hinzufügen": "Cannot scan? Add manually",
  "Geben Sie den sechsstelligen Code aus Ihrer Authenticator-App ein, um Ihren Merkan-Zugang für {mandant} zu öffnen.": "Enter the six-digit code from your authenticator app to open your Merkan access for {mandant}.",
  "Einrichtung abschließen": "Complete setup",
  // Branchenneutrale Fassungen (Mandanten ohne Schiffsakte)
  "Suchen nach Vorgang, Kunde, Artikel, Teilenummer, Beleg …": "Search for case, customer, item, part number, document …",
  "Vorgang, Kunde, Artikel oder Teilenummer suchen": "Search for case, customer, item or part number",
  "Vorgang, Kunde, Artikel, Teilenummer, Beleg …": "Case, customer, item, part number, document …",
  "Exakte Vorgangs- oder Belegnummer und Enter öffnet direkt": "Exact case or document number plus Enter opens directly",
  "Fragen zu Vorgängen, Kunden und offenen Posten": "Questions about cases, customers and open items",
  "Ich bin der KI-Assistent in Merkan und kenne die Vorgänge, Kunden, Belege und das Wiki dieses Unternehmens, so weit deine Rolle sie sehen darf.": "I am the AI assistant in Merkan and know this company's cases, customers, documents and wiki, as far as your role is allowed to see them.",
  "Welche Artikel kauft der Kunde am häufigsten?": "Which items does this customer buy most often?",
  "Der Zugriff auf die Kamera wurde nicht erlaubt. Bitte in den Browsereinstellungen freigeben.": "Camera access was not allowed. Please allow it in your browser settings.",
  "Keine Kamera gefunden.": "No camera found.",
  "Scannen": "Scan",
  "Barcode mit der Kamera, einem Handscanner oder per Eingabe": "Barcode via camera, handheld scanner or manual entry",
  "Kamerabild": "Camera image",
  "Handscanner: einfach scannen. Kamera: Barcode in den Rahmen halten.": "Handheld scanner: just scan. Camera: hold the barcode inside the frame.",
  "Kamera aus": "Camera off",
  "Kamera starten": "Start camera",
  "Code eingeben oder scannen": "Enter or scan code",
  "EAN erkannt": "EAN recognised",
  "Artikel öffnen": "Open item",
  "{n} offener Vorgang mit diesem Artikel": "{n} open case with this item",
  "{n} offene Vorgänge mit diesem Artikel": "{n} open cases with this item",
  "Kein offener Vorgang mit diesem Artikel.": "No open case with this item.",
  "Wareneingang gebucht: {n} {einheit} zu {vorgang}.": "Goods receipt posted: {n} {einheit} for {vorgang}.",
  "{e} von {m} {einheit}": "{e} of {m} {einheit}",
  "Eingang buchen": "Post receipt",
  "EAN {ean} dem Artikel {nr} zugeordnet.": "EAN {ean} assigned to item {nr}.",
  "Zum Code {code} gibt es keinen Artikel, keine Bestellung und keinen Vorgang.": "There is no item, purchase order or case for code {code}.",
  "Barcode einem Artikel zuordnen": "Assign barcode to an item",
  "Danach erkennt Merkan den Artikel bei jedem Scan.": "Merkan will then recognise the item on every scan.",
  "Artikel suchen: Bezeichnung, Artikel- oder Teilenummer": "Search item: description, item or part number",
  "hat schon EAN {ean}": "already has EAN {ean}",
  "Neuen Artikel mit diesem Barcode anlegen": "Create new item with this barcode",
  "Gesucht wurde nach EAN, Artikelnummer, Teilenummer des Herstellers, Bestell- und Vorgangsnummer.": "Searched by EAN, item number, manufacturer part number, purchase order and case number.",
  "Scannen: Barcode per Kamera oder Handscanner": "Scan: barcode via camera or handheld scanner",
  "Die Prüfziffer der EAN stimmt nicht. Bitte die Ziffern prüfen oder neu scannen.": "The EAN check digit is wrong. Please check the digits or scan again.",
  "Die EAN hat 8, 12, 13 oder 14 Ziffern.": "The EAN has 8, 12, 13 or 14 digits.",
  "EAN (Barcode)": "EAN (barcode)",
  "Prüfziffer oder Länge stimmt nicht": "Check digit or length is wrong",
  "Mit dem Handscanner direkt ins Feld scannen": "Scan directly into the field with a handheld scanner",
  "13 Ziffern": "13 digits",
  "EAN": "EAN",
  "Identität erneut bestätigen": "Confirm your identity again",
  "Zum Schutz Ihrer Daten verlangt {mandant} in regelmäßigen Abständen eine erneute Bestätigung. Geben Sie den sechsstelligen Code aus Ihrer Authenticator-App ein, danach arbeiten Sie direkt weiter.": "To protect your data, {mandant} asks for confirmation at regular intervals. Enter the six-digit code from your authenticator app and continue right where you left off.",
  "Nächste Code-Abfrage": "Next code prompt",
  "nur bei der Anmeldung": "only at sign-in",
  "Kein Artikel im Stamm, aber Positionen mit dieser Teilenummer:": "No item in master data, but positions with this part number:",
  "{n} offene Position": "{n} open position",
  "{n} offene Positionen": "{n} open positions",
  "Suchen …": "Search …",
  "Auf diesem Gerät {dauer} nicht erneut fragen": "Don't ask again on this device for {dauer}",
  "1 Tag": "1 day",
  "1 Stunde": "1 hour",
  "{n} Stunden": "{n} hours",
  "Zweiter Faktor über bekanntes Gerät": "Second factor via known device",
  // Passkeys
  "Der Dienst für Passkeys ist gerade nicht erreichbar. Bitte später erneut versuchen.": "The passkey service is currently unavailable. Please try again later.",
  "Dieser Passkey ist auf dem Gerät bereits hinterlegt.": "This passkey is already registered on this device.",
  "Passkeys sind unter dieser Adresse nicht möglich.": "Passkeys are not available at this address.",
  "Der Vorgang ist fehlgeschlagen. Bitte erneut versuchen.": "The action failed. Please try again.",
  "Der Passkey konnte nicht gespeichert werden.": "The passkey could not be saved.",
  "Die Bestätigung ist fehlgeschlagen.": "Confirmation failed.",
  "Warte auf Bestätigung …": "Waiting for confirmation …",
  "Mit Passkey bestätigen": "Confirm with passkey",
  "oder Code eingeben": "or enter code",
  "Passkey „{name}“ hinzugefügt": "Passkey \"{name}\" added",
  "Passkey „{name}“ entfernen?": "Remove passkey \"{name}\"?",
  "Passkey entfernt": "Passkey removed",
  "Der Passkey konnte nicht entfernt werden.": "The passkey could not be removed.",
  "Passkeys": "Passkeys",
  "Anmeldung mit Face ID, Touch ID, Fingerabdruck oder Windows Hello bestätigen statt mit dem Code. Freiwillig, der Authenticator bleibt als Rückfallweg bestehen.": "Confirm sign-in with Face ID, Touch ID, fingerprint or Windows Hello instead of the code. Optional, the authenticator remains as a fallback.",
  "Passkey hinzufügen": "Add passkey",
  "Dieser Browser unterstützt keine Passkeys.": "This browser does not support passkeys.",
  "Zur Sicherheit einmal den Code aus der Authenticator-App eingeben": "For security, enter the code from your authenticator app once",
  "Bestätigen und fortfahren": "Confirm and continue",
  "Noch kein Passkey hinterlegt.": "No passkey added yet.",
  "Adresse": "Address",
  "Hinzugefügt": "Added",
  "Zuletzt genutzt": "Last used",
  "synchronisiert": "synced",
  "andere Adresse": "other address",
  "Passkey entfernen": "Remove passkey",
  "Passkey hinzugefügt": "Passkey added",
  "Mit Passkey bestätigt": "Confirmed with passkey",
  "PDF ansehen": "View PDF",
  "Vollbild": "Full screen",
  "In neuem Tab öffnen": "Open in new tab",
  "Vergrößern": "Zoom in",
  "Zoom": "Zoom",
  "Wird geladen …": "Loading …",
  "PDF wird geladen …": "Loading PDF …",
  "Das PDF konnte nicht angezeigt werden.": "The PDF could not be displayed.",
  "Für diesen Dateityp gibt es keine Vorschau.": "There is no preview for this file type.",
  "Seite {n}": "Page {n}",
  "Die Datei konnte nicht geladen werden.": "The file could not be loaded.",
  "Datei öffnen": "Open file",
} satisfies Record<string, string>;
